import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

// Components
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';

class BrowserThumb extends Component {
    render () {

        const altText = this.props.imageAlt;
        let caption;
        let link;

        if ( this.props.link !== '' ) {
            link = <NavLink className="browser-thumb__link" to={this.props.link}></NavLink>;
        }

        if ( this.props.title !== '' ) {
            caption = 
            <figcaption>
            	<span className="browser-thumb__dots">
            		<span className="browser-thumb__dot"></span>
            		<span className="browser-thumb__dot"></span>
            		<span className="browser-thumb__dot"></span>
            	</span>
            	<h3 className="fx-txt-a"><span className="fx-txt-a__text">{this.props.title}</span></h3>
            </figcaption>;
        }

        return (
            <figure className={ `browser-thumb fx-trigger shadow ${this.props.classes}` } >
            	{caption}
                <ProgressiveImage 
                    src={this.props.src}
                    srcLow={this.props.srcLow}
                    width={this.props.width}
                    height={this.props.height}
                    bgColor={this.props.bgColor} 
                    alt={altText} 
                />
               {link}
            </figure>
        );
    }
}

export default BrowserThumb;


// WEBPACK FOOTER //
// ./src/components/BrowserThumb/BrowserThumb.js